import { useState } from 'react';

const useMedias = () => {
  const [baseUrl] = useState(process.env.GATSBY_CDN_BASEURL_ENDPOINT);

  const getNode = (medias, key) => {
    if (!Array.isArray(medias)) return;
    return medias?.find((i) => i.node.drupal_internal__mid === key)?.node;
  };

  const processUrl = (path) => {
    if (!path) return undefined;
    return `${path}`;
  };

  const getImage = (imageArray, key) => {
    return (
      getNode(imageArray, key)?.relationships?.field_media_image || {
        uri: { url: undefined },
      }
    );
  };

  const getVideo = (videoArray, key) => {
    return (
      getNode(videoArray, key)?.relationships?.field_media_video_file || {
        uri: { url: undefined },
      }
    );
  };

  const getAudio = (audioArray, key) => {
    return (
      getNode(audioArray, key)?.relationships?.field_media_audio_file || {
        uri: { url: undefined },
      }
    );
  };

  const getDocument = (documentArray, key) => {
    const documentNode = getNode(documentArray, key);
    return {
      ...documentNode?.relationships?.field_media_document,
      ...documentNode?.field_media_document,
    };
  };

  return { baseUrl, processUrl, getImage, getVideo, getAudio, getDocument };
};

export default useMedias;
